// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__n7HTu","errorText":"ErrorPage_errorText__k+sHj","heading":"ErrorPage_heading__bZLQr"};